"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.COUNTER = void 0;
const COUNTER = exports.COUNTER = 'counter';
